<div class="flex flex-col flex-1 min-h-0 w-full">
  <div class="flex flex-col mb-2 items-center shrink-0">
    <div class="w-auto ml-auto">
      <button
        mat-icon-button
        class="!h-7 !w-7"
        type="button"
        data-testid="update-documents-close"
        (click)="onCancel()"
        [attr.aria-label]="'Close' | translate">
        <mat-icon svgIcon="close-affordance" class="icon-size [--icon-size:40px]"/>
      </button>
    </div>

    @if (!showAddNewPicker) {
      <h1 class="headline-small text-primary flex-1 mb-3 text-center">{{ 'Select blueprints' | translate }}</h1>
      <div
        class="flex items-center gap-2 w-full px-3 py-2 rounded-[4px] bg-tertiary-99 border border-tertiary-50"
        data-testid="update-documents-warning"
        role="status">
        <mat-icon class="material-symbols-outlined !text-tertiary-30 shrink-0">warning</mat-icon>
        <p class="label-large !text-tertiary-30 m-0">
          {{ 'All documents will regenerate with updated data; previous edits will be lost' | translate }}
        </p>
      </div>
    } @else {
      <h1 class="headline-small text-primary flex-1 text-center">{{ 'Select blueprints' | translate }}</h1>
      <p class="body-medium text-on-surface-variant text-center px-4">
        {{ 'Select additional blueprints to generate from your updated consultation content' | translate }}
      </p>
    }
  </div>

  <div class="flex flex-col flex-1 min-h-0 w-full min-w-0 mb-6 overflow-hidden">
    @if (!showAddNewPicker) {
      <app-template-selector
        class="flex-1 min-h-0 flex flex-col"
        [selectionKey]="updateSelectionKey"
        [preserveOrder]="true"
        [loading]="isLoading"
        [templates]="updateListTemplates"
        [selectedTemplates]="selectedTemplates"
        [disabledTemplates]="disabledTemplates"
        [approvedTemplates]="approvedTemplates"
        (selectionChange)="onUpdateSelectionChange($event)">
      </app-template-selector>
    } @else {
      <app-template-selector
        class="flex-1 min-h-0 flex flex-col"
        selectionKey="add-new"
        [preserveOrder]="true"
        [loading]="isLoading"
        [templates]="availableNewTemplates"
        [selectedTemplates]="pickerSelectedTemplates"
        (selectionChange)="onPickerSelectionChange($event)">
      </app-template-selector>
    }
  </div>

  <app-dialog-footer class="!flex !flex-col !gap-3 !p-0 !pb-2 !mt-auto shrink-0 !items-stretch !min-h-0">
    @if (!showAddNewPicker) {
      <div class="flex w-full gap-3">
        <button
          class="flex-1 w-full"
          mat-stroked-button
          type="button"
          data-testid="update-documents-add-new"
          (click)="openAddNewTemplatesStep()"
          [disabled]="isSaving || isLoading">
          {{ 'Add more blueprints' | translate }}
        </button>
        <button
          class="flex-1 w-full !bg-primary !text-on-primary disabled:opacity-40"
          mat-flat-button
          type="button"
          data-testid="update-documents-confirm"
          (click)="onUpdateSelected()"
          [disabled]="isSaving || selectedTemplates.length === 0">
          <app-loading-spinner [loading]="isSaving" [diameter]="20">
            {{ 'Confirm selection' | translate }}
          </app-loading-spinner>
        </button>
      </div>
      <div class="flex w-full">
        <button
          class="w-full"
          mat-button
          type="button"
          data-testid="update-documents-skip"
          (click)="onSkipForNow()"
          [disabled]="isSaving">
          {{ 'Skip for now' | translate }}
        </button>
      </div>
    } @else {
      <div class="flex w-full">
        <button
          class="w-full !bg-primary !text-on-primary disabled:opacity-40"
          mat-flat-button
          type="button"
          data-testid="update-documents-back"
          (click)="closeAddNewTemplatesStep()"
          [disabled]="isSaving">
          {{ 'Confirm selection' | translate }}
        </button>
      </div>
    }
  </app-dialog-footer>
</div>
